import { maxLength, minLength } from '@seek/validators-js';
import type { FieldValues, RegisterOptions, Validate } from 'react-hook-form';

import type { TextFormFields } from './types.ts';

export const atLeastOne = (message: string) => (value: unknown[]) => {
  if (value.length === 0) {
    return message;
  }
};

export const nonEmptyString = (message: string) => (value: string) => {
  if (!/\S/.test(value)) {
    return message;
  }
};

export const createTextFieldValidationRules = (
  element: TextFormFields,
): RegisterOptions => {
  const rules: RegisterOptions = {
    required: element.required ? 'This field is required' : false,
  };

  const validations: Record<string, Validate<string, FieldValues>> = {};

  if (element.required) {
    validations.nonEmpty = nonEmptyString('Field cannot be empty');
  }

  if (element.maxLength) {
    validations.maxLength = (value: string) => {
      const isValid = maxLength.test({
        value,
        validatorProps: { max: element.maxLength! },
        formValues: undefined,
      });
      return isValid || `Maximum ${element.maxLength} characters allowed`;
    };
  }

  if (element.minLength) {
    validations.minLength = (value: string) => {
      const isValid = minLength.test({
        value,
        validatorProps: { min: element.minLength! },
        formValues: undefined,
      });
      return isValid || `Minimum ${element.minLength} characters required`;
    };
  }

  if (Object.keys(validations).length > 0) {
    rules.validate = validations;
  }

  return rules;
};
